import { useContext } from "react";
import { CustomerContext } from "./CustomerPage";
import { Select } from "components/base/Form";

const ShippingZoneView = () => {
  const { customer, save } = useContext(CustomerContext);

  return (
    <div className="card">
      <h5>Shipping Zone</h5>

      <div className="opacity-70">
        Shipping Zone is used to check the shipping cost.
      </div>
      <div className="mt-2">
        <Select
          value={customer.shippingZone}
          onChange={(e) =>
            save({
              variables: {
                id: customer.id,
                shippingZone: e.target.value,
              },
            })
          }
        >
          <option value="US">US</option>
          <option value="EU">EU</option>
        </Select>
      </div>
    </div>
  );
};

export default ShippingZoneView;
